import {internalRoutes} from "./internalRoutes";
import {kHomeTexts, kSystemDrawerNavText} from "./texts";
import {kSystemIcons} from "./icons";

// Used through the app to list a set of navigation related
// constants

// ---- About screen sub navigation
export const kAboutNavigation = [
    {
        icon: 'track_changes',
        title: "Notre mission",
        smallTitle: "Mission",
    },
    {
        icon: 'psychology',
        title: "Notre méthode",
        smallTitle: "Méthode",
    },
    {
        icon: 'groups',
        title: "Notre équipe",
        smallTitle: "Équipe",
    },
    {
        icon: 'send',
        title: "Nous contacter",
        smallTitle: "Contact",
    },
]

// ---- homeScreen
export const kHomeFooterAboutNavItems = [
    {
        text: "Notre mission",
        link: { pathname: internalRoutes.about, state: { tab: 0 } },
    },
    {
        text: "Notre méthode",
        link: { pathname: internalRoutes.about, state: { tab: 1 } },
    },
    {
        text: "Qui sommes-nous ?",
        link: { pathname: internalRoutes.about, state: { tab: 2 } },
    },
]

export const kHomeFooterActivityNavItems = [
    {
        text: "Cours et exercices",
        link: { pathname: internalRoutes.courses},
    },
    {
        text: "Glossaire",
        link: { pathname: internalRoutes.glossary},
    },
    {
        text: "Jeux",
        link: { pathname: internalRoutes.games},
    }
]

export const kHomeFooterLegalNavItems = [
    {
        text: "Politique de confidentialité",
        link: { pathname: internalRoutes.privacy},
    },
    {
        text: "Mentions légales",
        link: { pathname: internalRoutes.legals},
    }
]

// ---- SYSTEM
export const kSystemMainNavigationItems = [
    {
        name: kHomeTexts.navCourses,
        route: internalRoutes.courses,
    },
    {
        name: kHomeTexts.navGlossary,
        route: internalRoutes.glossary,
    },
    {
        name: kHomeTexts.navGames,
        route: internalRoutes.games,
    },
]

export const kSystemDrawerMainNavigationItems = [
    {
        name: kSystemDrawerNavText.courses,
        icon: kSystemIcons.book,
        route: internalRoutes.courses,
        tooltip: "Cours et exercices"
    },
    {
        name: kSystemDrawerNavText.glossary,
        icon: kSystemIcons.dictionary,
        route: internalRoutes.glossary,
        tooltip: "Glossaire"
    },
    {
        name: kSystemDrawerNavText.games,
        icon: kSystemIcons.games,
        route: internalRoutes.games,
        tooltip: "Jeux"
    },
]

export const kSystemDrawerAboutNavigationItems = [
    {
        name: kSystemDrawerNavText.themes,
        icon: kSystemIcons.balance,
        route: internalRoutes.themes,
    },
    {
        name: kSystemDrawerNavText.about,
        icon: kSystemIcons.about,
        route: internalRoutes.about,
    },
]

export const kSystemDrawerLegalsNavigationItems = [
    {
        name: kHomeTexts.navLegals,
        icon: kSystemIcons.assignment,
        route: internalRoutes.legals,
    },
    {
        name: kHomeTexts.navPrivacy,
        icon: kSystemIcons.lock,
        route: internalRoutes.privacy,
    }
]